import React, { useState, useEffect } from 'react';
import {
    Button,
    Col,
    FormGroup,
    Label,
    Modal,
    ModalBody,
    ModalFooter,
    ModalHeader,
    Row,
    Input
} from "reactstrap";
import Select from "react-select";
import Swal from "sweetalert2";
import { useDispatch } from "react-redux";
import { empresaAction, visitaAction } from "../_actions";

export const ModalSelectEmpresa = ({ openModalSelectEmpresa, handleCloseModalSelectEmpresa, props }) => {
    const [empresasSelecionadas, setEmpresasSelecionadas] = useState([]);
    const [financeiro, setFinanceiro] = useState(false);
    const dispatch = useDispatch();

    useEffect(() => {
        if (openModalSelectEmpresa) {
            dispatch(empresaAction.getEmpresasSelect());
            setFinanceiro(false);
            setEmpresasSelecionadas([]);
        }
    }, [openModalSelectEmpresa, dispatch]);

    const handleSelectChange = prop => event => {
        if (prop === "id_empresa") {
            setEmpresasSelecionadas(event ? event.map(x => x.value) : []);
        }
    };

    const renderOptionsEmpresa = () => {
        if (!props.empresa || !props.empresa.empresa) return [];
        return props.empresa.empresa.map((p, i) => ({
            value: p.Value,
            label: p.Text
        }));
    };

    const handleGerarRelatorioEmpresas = () => {
        var data = new Date();
        var dia = String(data.getDate()).padStart(2, "0");
        var mes = String(data.getMonth() + 1).padStart(2, "0");
        var ano = data.getFullYear();
        var dataAtual = ano + "-" + mes + "-" + dia;

        const idEmpresa = empresasSelecionadas.length > 0 ? empresasSelecionadas[0] : null;
        const idsEmpresas = empresasSelecionadas.length > 0 ? empresasSelecionadas.join(",") : null;

        let payload = {
            id_fazenda: 0,
            data: dataAtual,
            tipo_relatorio: "EM",
            id_empresa: idEmpresa ? parseInt(idEmpresa) : null,
            ids_empresas: idsEmpresas,
            financeiro: financeiro
        };

        console.log("payload", payload);
        dispatch(visitaAction.createVisita(payload, true));
    };

    return (
        <div>
            <Modal isOpen={openModalSelectEmpresa} onClose={handleCloseModalSelectEmpresa} aria-labelledby="form-dialog-title">
                <ModalHeader id="form-dialog-title">Gerar relat&oacute;rio com empresas e animais ativos</ModalHeader>
                <ModalBody>
                    <Row>
                        <Col>
                            <FormGroup className="mt-3">
                                <Label className="left" for="selecionarEmpresa">Selecione as empresas: (Opcional)</Label>
                                {openModalSelectEmpresa &&
                                    <Select
                                        classNamePrefix="select"
                                        isMulti
                                        value={renderOptionsEmpresa().filter(option =>
                                            empresasSelecionadas.includes(option.value)
                                        )}
                                        onChange={handleSelectChange("id_empresa")}
                                        isSearchable
                                        placeholder="Todas as empresas..."
                                        id="id_empresa"
                                        name="id_empresa"
                                        options={renderOptionsEmpresa()}
                                    />
                                }
                                <small className="text-muted">
                                    Deixe em branco para incluir todas as empresas no relatorio.
                                </small>
                            </FormGroup>
                            <FormGroup check className="mb-2">
                                <Input
                                    type="checkbox"
                                    id="financeiro"
                                    checked={financeiro}
                                    onChange={(e) => { setFinanceiro(e.target.checked); setEmpresasSelecionadas([]); }}
                                />{" "}
                                <Label for="financeiro" check className="ml-2">Listar fazendas que utilizam o Financeiro tambem</Label>
                            </FormGroup>
                        </Col>
                    </Row>
                </ModalBody>
                <ModalFooter>
                    <Button onClick={handleCloseModalSelectEmpresa} color="secondary">Cancelar</Button>
                    <Button onClick={handleGerarRelatorioEmpresas} color="primary">Gerar relat&oacute;rio</Button>
                </ModalFooter>
            </Modal>
        </div>
    );
};
